"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GovernorBravoDelegateStorageV1Factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        constant: true,
        inputs: [],
        name: "admin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "initialProposalId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "latestProposalIds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "pendingAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "proposalCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "proposalThreshold",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "proposals",
        outputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "proposer",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "eta",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "startBlock",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "endBlock",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "forVotes",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "againstVotes",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "abstainVotes",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "canceled",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "executed",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "timelock",
        outputs: [
            {
                internalType: "contract TimelockInterface",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "tonic",
        outputs: [
            {
                internalType: "contract TonicInterface",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "votingDelay",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "votingPeriod",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
class GovernorBravoDelegateStorageV1Factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.GovernorBravoDelegateStorageV1Factory = GovernorBravoDelegateStorageV1Factory;
GovernorBravoDelegateStorageV1Factory.bytecode = _bytecode;
GovernorBravoDelegateStorageV1Factory.abi = _abi;
//# sourceMappingURL=GovernorBravoDelegateStorageV1Factory.js.map